module.exports = __webpack_public_path__ + "static/media/snowflake.37da57fd.svg";